import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { AppPermissionsPipe, MaterialModuleMobi } from 'shared-library';

@NgModule({
  declarations: [PrivacyPolicyComponent],
  imports: [
    CommonModule,
    FormsModule,
    QuillModule.forRoot(),
    MaterialModuleMobi,
    AppPermissionsPipe
  ],
  exports:[PrivacyPolicyComponent]
})
export class PrivacyPolicyModule { }
